<template>
  <div>
    <b-form-group>
      <b-row slot="label" align-v="center">
          <b-col>{{ $t('edit_current_category') }}</b-col>
          <b-col class="text-right">
          <b-link v-on:click="editCategory">
              <icon name="pencil-alt"/>
          </b-link>
          </b-col>
      </b-row>
      <b-form-input type="text"
                      v-model="categorySelectedName"
                      disabled>
      </b-form-input>
    </b-form-group>
    <b-modal v-model="categoryModal" :title="$t('modal_title_select_category')">
      <div class="div-category">
        <v-tree ref='category' v-bind:data='items' v-bind:tpl='tpl' v-on:node-click='selected'/>
      </div>
      <div slot="modal-footer" class="w-100">
        <b-btn size="sm" class="float-right" variant="primary" v-on:click="confirmCategory">
          {{ $t('_save') }}
        </b-btn>
        <b-btn size="sm" class="float-right" variant="light" v-on:click="categoryModal=false">
          {{ $t('_cancel') }}
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>

import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'CategoryInput',
  data () {
    return {
      categorySelectedName: '',
      categorySelectedId: '',
      newCategorySelectedName: '',
      newCategorySelectedId: '',
      categoryModal: false,
      items: [],
      hasSelected: false
    }
  },
  computed: {
    ...mapGetters([
      'shappyInfo',
      'accountInfo'
    ])
  },
  methods: {
    ...mapActions([
      'updateAccountInfoAPI',
      'getCategorySelectedAPI',
      'getCategoryListAPI'
    ]),
    ...mapMutations([
      'setAccountInfo'
    ]),
    editCategory () {
      let param = {'publicKey': this.accountInfo.publicShopKey,
        'categoryId': this.accountInfo.categoryId
      }
      this.getCategoryListAPI(param).then((result2) => {
        this.items = result2.categories
        this.categoryModal = true
      })
    },
    selected (node) {
      this.hasSelected = true
      this.newCategorySelectedName = node.name
      this.newCategorySelectedId = node.id
    },
    tpl (node) {
      let titleClass = ''
      let icon = ''
      if (this.newCategorySelectedId === '') {
        if (node.id === this.categorySelectedId) {
          titleClass = 'link node-selected'
          icon = 'check-square'
          this.newCategorySelectedName = node.name
          this.newCategorySelectedId = node.id
        } else {
          titleClass = 'link'
          icon = 'folder'
        }
      } else if (this.hasSelected === true) {
        titleClass = node.selected && node.id === this.newCategorySelectedId ? 'link node-selected' : 'link'
        icon = node.selected && node.id === this.newCategorySelectedId ? 'check-square' : 'folder'
      } else {
        titleClass = node.id === this.newCategorySelectedId ? 'link node-selected' : 'link'
        icon = node.id === this.newCategorySelectedId ? 'check-square' : 'folder'
      }

      return <span>
        <icon name={icon} class="folder-category" />
        <span domPropsInnerHTML={node.name} onClick={() => {
          this.$refs.category.nodeSelected(node)
        }} class={titleClass}>
        </span>
      </span>
    },
    confirmCategory () {
      let param = {'appID': this.shappyInfo.appId,
        'channelID': this.shappyInfo.channelId,
        'customToken': this.shappyInfo.customToken,
        'categoryID': this.newCategorySelectedId,
        'domain': this.shappyInfo.domain
      }
      this.updateAccountInfoAPI(param).then((result) => {
        this.setAccountInfo({'categoryId': this.newCategorySelectedId})
        this.hasSelected = false
        this.categoryModal = false
        this.categorySelectedName = this.newCategorySelectedName
        this.categorySelectedId = this.newCategorySelectedId
      })
    }
  },
  created () {
    if (this.accountInfo.categoryId) {
      let param = {'publicKey': this.accountInfo.publicShopKey, 'categoryId': this.accountInfo.categoryId}
      this.getCategorySelectedAPI(param).then((result) => {
        this.categorySelectedName = result.categories.name
      })
    }
    this.categorySelectedId = this.accountInfo.categoryId
  }
}
</script>

<style lang="scss" scoped>
.div-category {
  height: 200px;
  overflow: auto;
  .folder-category {
    margin-left: 10px;
    margin-right: 5px;
  }
  .link {
    cursor: pointer;
  }
}
</style>
